const rootPath = '/svg';

const svgFiles = {
  genericUser: `${rootPath}/generic-user.svg`,
  calendarGray: `${rootPath}/calendarGray.svg`,
  handshakeGray: `${rootPath}/handshakeGray.svg`,
  handshakePurple: `${rootPath}/handshakePurple.svg`,
  arrowRightCurvedWhite: `${rootPath}/arrow-right-curved-white.svg`,
  arrowRightLong: `${rootPath}/long-arrow-right.svg`,
  appStoreBadge: `${rootPath}/app-store.svg`,
  playStoreBadge: `${rootPath}/play-store.svg`,
  play: `${rootPath}/play.svg`,
};

export default svgFiles;
